import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { ShareService } from 'src/app/services/share.service';
import { UserState } from 'src/app/store/reducers/user.reducers';
import { selectCompanyId } from 'src/app/store/selectors/user.selectors';

@Component({
  selector: 'app-import-project',
  templateUrl: './import-project.component.html',
  styleUrls: ['./import-project.component.scss']
})
export class ImportProjectComponent implements OnInit {
  @Output() importPorjectEvent = new EventEmitter<any>();
  companyId: any = null;
  public inputCode = "";
  constructor(
    private shareService: ShareService,
    private toastrService: ToastrService,
    private userStore: Store<{ user: UserState }>
  ) { }

  ngOnInit(): void {
    this.userStore.select(selectCompanyId).subscribe(companyId => {
      this.companyId = companyId;
    });
  }

  public closeModal(): void {
    this.importPorjectEvent.emit({ close: true, code: null });
  }

  /***
   * refers to importModalActions method of SharedWithMeComponent, line 50
   */
  public save(): void {

    this.shareService.importScreening({ sharedScreeningReflowId: this.inputCode, companyId: this.companyId })
      .subscribe(res => {

        if (res == true) {
          this.toastrService.success(
            "Shared assessment imported successfully. You can now use it in your calculations",
            "Imported successfully"
          );
          this.importPorjectEvent.emit({ close: true });
        } else {
          this.toastrService.error(
            "Failed to import shared assessment. Please check with your provider if the shared URL is correct",
            "Error"
          );
          this.importPorjectEvent.emit({ close: true });
        }
      }, () => {
        this.toastrService.error("An error occurred while importing. Please try again later.", "Error");
        this.importPorjectEvent.emit({ close: true });
      });
  }


}
